module.exports = __webpack_public_path__ + "img/meta_chill+copy.da512b4e.png";